import Connected from './Connected';

export default Connected;